import { BaseModel } from '../../base/base-model'

/**
 * @memberOf loavies.models.user
 * @constructor
 */
export class UpdateUserPublicDataModel extends BaseModel {
  /**
   * @param {string} [storeName]
   * @param {boolean} [storeIsClosed]
   * @param {string} [storeGridType]
   * @param {number} [amountOfStoreViews]
   * @param {number} [amountOfFollowers]
   * @param {string[]} [followingUsers]
   * @param {string} [banner]
   * @param {string[]} [userLabels]
   */
  constructor({
    storeName,
    storeIsClosed,
    storeGridType,
    amountOfStoreViews,
    amountOfFollowers,
    followingUsers,
    banner,
    userLabels,
  }) {
    super()

    /** @type {string} */
    if (!this.isUndefined(storeName)) this.storeName = storeName

    /** @type {boolean} */
    if (!this.isUndefined(storeIsClosed)) this.storeIsClosed = storeIsClosed

    /** @type {string} */
    if (!this.isUndefined(storeGridType)) this.storeGridType = storeGridType

    /** @type {number} */
    if (!this.isUndefined(amountOfStoreViews)) this.amountOfStoreViews = amountOfStoreViews

    /** @type {number} */
    if (!this.isUndefined(amountOfFollowers)) this.amountOfFollowers = amountOfFollowers

    /** @type {string[]} */
    if (!this.isUndefined(followingUsers)) this.followingUsers = followingUsers

    /** @type {string} */
    if (!this.isUndefined(banner)) this.banner = banner

    /** @type {string[]} */
    if (!this.isUndefined(userLabels)) this.userLabels = userLabels
  }
}
